import type { ReactNode } from 'react';
import React from 'react';
import { Box } from '@balance-web/box';
import type { WithDataAttributeProp } from '@balance-web/core';

export const Body = ({
  children,
  data,
}: WithDataAttributeProp<{ children: ReactNode }>) => {
  return (
    <Box data={data} paddingX="medium" paddingY="large">
      {children}
    </Box>
  );
};
